import React from "react";

import { WagmiProvider } from "wagmi";
import { useWagmiConfig } from "hooks/useWagmi";

export default function WalletProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { wagmiConfig } = useWagmiConfig();

  if (!wagmiConfig) return <></>;

  return <WagmiProvider config={wagmiConfig}>{children}</WagmiProvider>;
}
